<template>
    <div class="container" style="margin-top: 7%;padding: 5%;" v-if="listado.length">
        <div class="row mb-3">
            <div class="col text-center">
                <h2 class="titulo">Blog</h2>
            </div>
        </div>
        <div class="row d-flex align-items-stretch">
            <!-- Columna Izquierda: Carrusel de Publicaciones -->
            <div class="col-md-8">
                <div id="publicacionesCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div v-for="(publicacion, index) in publicaciones" :key="publicacion.id"
                            :class="['carousel-item', { active: index === 0 }]">
                            <router-link :to="`/DetallePosts/${publicacion.id}`">
                                <img :src="'img/publicaciones/' + publicacion.image_path" class="d-block w-100"
                                    alt="...">
                                <div class="carousel-caption d-none d-md-block">
                                    <h3 style="color: white;">{{ publicacion.titulo }}</h3>
                                    <h5 style="color: white;">{{ publicacion.descripcion }}</h5>
                                    <h5 style="color: white;" class="fecha">{{ formatDate(publicacion.created_at) }}
                                    </h5>
                                </div>
                                <button class="btn btn-ver-mas">
                                    Ver más
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Columna Derecha: Tags/Categorías -->
            <div class="col-md-4">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center mb-2">
                            <h4 class="text-start me-2">
                                <i style="color:#ff9900;" class="fa fa-tags" aria-hidden="true"></i>&nbsp;Etiquetas
                            </h4>
                        </div>
                        <input type="text" class="form-control" placeholder="Buscar en Tags" v-model="query"
                            @input="filtrar" :disabled="loading">
                    </div>
                </div>
                <div class="row">
                    <div class="tags-container" style="max-height: 300px; overflow-y: auto;">
                        <ul class="list-group">
                            <li v-for="tag in tagsConPublicaciones" :key="tag.id"
                                class="list-group-item d-flex justify-content-between align-items-center"
                                :class="{ 'active-tag': tag.tag_id === tagSeleccionado }" style="cursor: pointer;"
                                :title="`Clic para mostrar información adicional sobre ${tag.tag}`"
                                @click="filtrarPorTag(tag)">
                                <div class="tag-title">{{ tag.tag }}</div>
                                <span class="badge bg-primary">{{ tag.publicaciones_count }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>


        <!-- Publicación Seleccionada -->
        <div v-if="publicacionSeleccionada !== null" class="selected-publicacion text-center">
            <h2 class="titulo">{{ publicacionSeleccionada.tag }}</h2>
            <hr class="linea-separadora" style="color: #ff9900;">
            <div class="contenido">
                <p>{{ publicacionSeleccionada.descripcion }}</p>
                <h4>Publicaciones Relacionadas:</h4>
                <section class="cards-wrapper">
                    <div class="card-grid-space" v-if="listado.length" v-for="(relacionada, index) in listado"
                        :key="relacionada.id">
                        <div class="num">{{ index + 1 }}</div>
                        <router-link :to="`/DetallePosts/${relacionada.id}`" class="card" href="#"
                            :style="{ '--bg-img': `url(img/publicaciones/${relacionada.image_path})` }">
                            <div class="card-content">
                                <h1 class="card-title">{{ relacionada.titulo }}</h1>
                                <p class="card-description">{{ relacionada.descripcion }}</p>
                                <div class="date">{{ formatDate(relacionada.created_at) }}</div>
                                <div class="tags">
                                    <div v-for="tag in relacionada.publicacion_tags" :key="tag" class="tag">{{
                                        tag.tag.name }}</div>
                                </div>

                            </div>
                            <button class="btn btn-ver-mas">
                                Ver más
                            </button>
                        </router-link>
                    </div>
                    <div v-else class="d-flex align-items-center text-center" style="margin-top: 20px;">
                        <i class="fa fa-exclamation-circle" style="font-size: 40px; color: #ff9900;"></i>
                        <h4>No hay publicaciones disponibles para esta etiqueta.</h4>
                    </div>

                </section>
                <!-- Controles de Paginación -->
                <div v-if="totalPages > 1" class="pagination-controls d-flex align-items-center text-center mt-4">
                    <button class="btn btn-primary" @click="paginate(currentPage - 1)" :disabled="currentPage === 1">
                        Anterior
                    </button>
                    <span class="mx-2">Página {{ currentPage }} de {{ totalPages }}</span>
                    <button class="btn btn-primary" @click="paginate(currentPage + 1)"
                        :disabled="currentPage === totalPages">
                        Siguiente
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="d-flex align-items-center text-center" style="margin-top: 7%;">
        <i class="fa fa-exclamation-circle" style="font-size: 40px; color: #ff9900;"></i>
        <h4>No hay publicaciones disponibles .</h4>
    </div>
</template>

<script>
export default {
    data() {
        return {
            query: '',
            loading: false,
            listado: [],
            publicaciones: [],
            tagsConPublicaciones: {},
            publicacionSeleccionada: null,
            tagSeleccionado: null,
            tagsConPublicaciones2: [],
            currentPage: 1,
            totalPages: 1,

        };
    },
    computed: {
        publicacionesFiltradas() {
            if (!this.query) {
                return this.listado;
            }
            const term = this.query.toLowerCase().trim();
            return this.listado.filter(publicacion =>
                publicacion.titulo.toLowerCase().includes(term) ||
                publicacion.subtitulo.toLowerCase().includes(term) ||
                publicacion.descripcion.toLowerCase().includes(term)
            );
        }
    },
    methods: {
        cargarBoletines() {
            this.loading = true;
            axios.get('/api/publicaciones_post/countPublicacionesPorTag')
                .then(response => {
                    //console.log(response.data)
                    this.listado = response.data.publicaciones;
                    this.publicaciones = response.data.publicaciones;
                    this.tagsConPublicaciones = response.data.filtros_tags;
                    this.tagsConPublicaciones2 = response.data.filtros_tags;
                    this.filtrarPorTag(response.data.filtros_tags[0]);
                    if ((response.data.filtros_tags[0].publicaciones_count / 20) > 1) {
                        this.currentPage = 1;
                        this.totalPages = response.data.filtros_tags[0].publicaciones_count / 20;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        filtrar() {
            // Convertimos la query a minúsculas para que la comparación no sea sensible a mayúsculas
            const queryLower = this.query.toLowerCase();

            // Si la query está vacía, restauramos todos los tags
            if (this.query.trim() === '') {
                // Asegúrate de tener una copia original de los tags para restaurarlos
                this.tagsConPublicaciones = this.tagsConPublicaciones2; // Asumiendo que `todosLosTags` tiene la lista original de tags
                return;
            }

            // Filtramos los tags que coincidan con la query en su nombre
            this.tagsConPublicaciones = this.tagsConPublicaciones2.filter(tag => {
                const matchesTag = tag.tag.toLowerCase().includes(queryLower);
                return matchesTag; // Retornamos true si coincide con el tag
            });
        },
        filtrarPorTag(tag) {
            // Si el tag seleccionado es el mismo, lo deseleccionamos (restauramos todo).
            if (this.tagSeleccionado === tag.tag_id) {
                this.tagSeleccionado = null;  // Deselecciona el tag
                this.listado = this.publicaciones;  // Restauramos todas las publicaciones
                this.publicacionSeleccionada = null; // Limpiamos publicación seleccionada (opcional)
                return;
            }

            // Si es el tag con ID 0, mostramos todas las publicaciones
            if (tag.tag_id === 0) {
                this.tagSeleccionado = 0;
                this.listado = this.publicaciones;  // Mostrar todas las publicaciones
                this.publicacionSeleccionada = tag;
            } else {
                // Filtramos las publicaciones según el tag seleccionado
                this.tagSeleccionado = tag.tag_id;
                this.publicacionSeleccionada = tag;
                this.paginate(1);
            }
        },
        paginate(pagina) {
            this.loading = true;
            axios.get('/api/publicaciones_post/countPublicacionesPorTagPaginate', {
                params: {
                    tag: this.tagSeleccionado, // Filtrar por etiqueta (opcional)
                    page: pagina, // Página actual para la paginación
                }
            })
                .then(response => {
                    //console.log(response.data)
                    const data = response.data;
                    this.listado = data.data;
                    this.currentPage = data.current_page;
                    this.totalPages = data.last_page;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatDate(date) {
            const fecha = new Date(date);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const año = fecha.getFullYear();
            return `${dia}/${mes}/${año}`;
        },
        mostrarPublicacion(publicacion) {
            this.publicacionSeleccionada = publicacion;
        },
        getAbsoluteImageUrl(relativeUrl) {
            return `${window.location.origin}${relativeUrl}`;
        }
    },
    beforeDestroy() {
        // Limpiamos los arrays y datos para liberar memoria
        this.query = '';
        this.listado = [];
        this.publicacionesFiltradas = [];
        this.tagsConPublicaciones = [];
        this.publicacionSeleccionada = null;
    },
    mounted() {
        this.cargarBoletines();
    }
}
</script>

<style scoped>
.row {
    display: flex;
}

.col-md-8,
.col-md-4 {
    display: flex;
    flex-direction: column;
    /* Asegura que los elementos dentro de cada columna se apilen verticalmente */
}

.tags-container {
    flex-grow: 1;
    /* Hace que la columna derecha ocupe el espacio restante */
}

.tag-title {
    flex-grow: 1;
    /* Permite que el título ocupe el espacio restante */
    text-align: center;
    /* Centra el texto horizontalmente */
}

.list-group-item {
    display: flex;
    justify-content: space-between;
    /* Mantiene el tag y el badge en extremos opuestos */
    align-items: center;
    /* Centra verticalmente los elementos */
    padding: 10px;
    /* Espaciado */
}

.sidebar {
    width: 20%;
    float: left;
}

.filters {
    display: inline-block;
    padding: 10px;
    margin: 0;
}

.filters div {
    margin-bottom: 20px;
    /* Ajustar el espaciado entre los filtros */
}

.filters h2 {
    margin-top: 0;
    margin-bottom: 10px;
}

.main-content {
    width: 60%;
    float: left;
    text-align: center;
}

.sidebar-right {
    width: 20%;
    float: left;
}

.input-group {
    position: relative;
    display: flex;
    align-items: stretch;
}

.input-group .form-control {
    flex-grow: 1;
    border-radius: 0;
}

.input-group-append .input-group-text {
    border-radius: 0;
    cursor: pointer;
}

.input-group-append .input-group-text i {
    margin: auto;
}

.tags-container {
    width: 100%;
    /* Ajusta el ancho de la tabla */
    border-collapse: collapse;
    /* Combina los bordes de la tabla */
}

.tags-container td {
    padding: 5px 10px;
    border-bottom: 1px solid #ccc;
    /* Borde inferior entre filas */
}

.selected {
    background-color: lightblue;
    /* Cambia el color de fondo según tu preferencia */
}

.tags-container .badge {
    text-align: right;
    /* Alinea el contador de publicaciones a la derecha */
}

.badge {
    margin-left: 10px;
    /* Espacio entre el tag y el contador */
    padding: 3px 8px;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
}

.publicacion {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Centra la imagen */
    margin-bottom: 20px;
    border-bottom: 2px solid #007bff;
    /* Borde inferior de 2 píxeles de grosor y color azul */
    padding-bottom: 10px;
}

.image-container {
    width: 200px;
    /* Ancho predefinido */
    height: 150px;
    /* Altura predefinida */
    overflow: hidden;
    /* Para recortar la imagen si es más grande que el contenedor */
}

.image-container img {
    width: 100%;
    /* Para asegurar que la imagen se ajuste al contenedor */
    height: auto;
    /* Para mantener la relación de aspecto original de la imagen */
}

.contenido {
    width: 100%;
    max-width: 600px;
    /* Ancho máximo del contenido */
    margin-top: 20px;
}

.contenido h5 {
    text-align: left;
    /* Alinea el título a la izquierda */
    margin-bottom: 10px;
}

.detalle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.detalle h6 {
    margin: 0;
    /* Elimina el margen del subtitulo */
}

.fecha {
    justify-content: right;
    align-items: right;
    text-align: right;
    /* Alinea la fecha a la derecha */
}

.spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    /* Altura deseada del spinner */
    font-size: 18px;
    color: #333;
    /* Color del texto del spinner */
}

.spinner::before {
    content: '';
    width: 30px;
    /* Ancho del spinner */
    height: 30px;
    /* Alto del spinner */
    border: 3px solid #333;
    /* Grosor y color del borde del spinner */
    border-radius: 50%;
    /* Forma redonda */
    border-top-color: transparent;
    /* Oculta una parte del borde para crear la animación */
    border-right-color: transparent;
    animation: spin 1s linear infinite;
    /* Animación de giro */
}

.scroll-container {
    max-height: auto;
    /* Ajusta la altura máxima según sea necesario */
    overflow-y: auto;
    margin-right: 2%;
}

/* Personaliza la barra de desplazamiento para navegadores webkit (Chrome, Safari, Edge) */
.scroll-container::-webkit-scrollbar {
    width: 12px;
    /* Ajusta el ancho de la barra de desplazamiento */
}

.scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* Color del track (fondo) */
}

.scroll-container::-webkit-scrollbar-thumb {
    background-color: #ff9900;
    /* Color del pulgar (la parte que se mueve) */
    border-radius: 10px;
    /* Bordes redondeados */
    border: 2px solid #f1f1f1;
    /* Añade un borde para dar un efecto de espacio */
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* Color del pulgar cuando se pasa el mouse por encima */
}

.pagination-controls {
    display: flex;
    justify-content: center;
    /* Centrar horizontalmente */
    align-items: center;
    /* Alinear verticalmente */
    gap: 10px;
    /* Espacio entre botones */
    width: 100%;
    /* Ocupar todo el ancho del contenedor */
}

@keyframes spin {
    from {
        transform: rotate(0deg);
        /* Rotación inicial */
    }

    to {
        transform: rotate(360deg);
        /* Rotación final */
    }
}

.btn-outline-navyblue {
    color: #333;
    /* Color del texto */
    background-color: transparent;
    /* Fondo transparente */
    border-color: #06283c;
    /* Color del borde */
}

.btn-outline-navyblue:hover {
    color: white;
    /* Color del texto al pasar el mouse */
    background-color: #06283c;
    /* Fondo al pasar el mouse */
    border-color: #06283c;
    /* Color del borde al pasar el mouse */
}

.btn-outline-navyblue.disabled,
.btn-outline-navyblue:disabled {
    color: #06283c;
    /* Color del texto cuando está deshabilitado */
    background-color: transparent;
    /* Fondo transparente cuando está deshabilitado */
}

.btn-outline-navyblue:not(:disabled):not(.disabled):active,
.btn-outline-navyblue:not(:disabled):not(.disabled).active,
.show>.btn-outline-navyblue.dropdown-toggle {
    color: white;
    /* Color del texto al hacer clic */
    background-color: #06283c;
    /* Fondo al hacer clic */
    border-color: #06283c;
    /* Color del borde al hacer clic */
}



.tab-responsive {
    display: none;
}

.cards-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    /* Reduce el tamaño mínimo de las columnas */
    gap: 1rem;
    padding: 2rem;
}

.card {
    --bg-filter-opacity: 0.5;
    background-image: linear-gradient(rgba(0, 0, 0, var(--bg-filter-opacity)),
            rgba(0, 0, 0, var(--bg-filter-opacity))), var(--bg-img);
    height: 300px;
    /* Altura más baja */
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    color: white;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-decoration: none;
}

.card-content {
    text-align: center;
    width: 100%;
    max-height: 150px;
    /* Limita el contenido */
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.card-title {
    font-size: 1rem;
    /* Tamaño más pequeño */
    margin: 0;
    font-weight: bold;
}

.card-description {
    font-size: 0.8rem;
    /* Reducir el tamaño de la descripción */
    margin: 0.3rem 0;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.date {
    font-size: 0.7rem;
    /* Tamaño reducido para la fecha */
    opacity: 0.8;
}

.tags {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.3rem;
    margin-top: 0.3rem;
}

.tag {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 5px;
    padding: 0.1rem 0.4rem;
    font-size: 0.7rem;
}

.btn-ver-mas {
    margin-top: 0.5rem;
    padding: 0.3rem 0.6rem;
    background-color: #ff9900;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    font-size: 0.8rem;
    /* Botón más pequeño */
    transition: background-color 0.3s;
}

.btn-ver-mas:hover {
    background-color: #e68a00;
}

.card-grid-space .num {
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    font-size: 1rem;
    color: white;
    opacity: 0.8;
}

.active-tag {
    background-color: #ff9900 !important;
    /* Cambia el color al hacer clic */
    color: white;
}

.info {
    font-size: 1.2em;
    display: flex;
    padding: 1em 3em;
    height: 3em;
}

.info img {
    height: 3em;
    margin-right: 0.5em;
}

.info h1 {
    font-size: 1em;
    font-weight: normal;
}


@media screen and (max-width: 768px) {
    .tab-normal {
        display: none;
    }

    .tab-responsive {
        display: block;
    }

    .responsivemetod {
        top: 50%;
    }

    .main-content {
        display: none;

    }

    .sidebar-slider {
        position: fixed;
        top: 5%;
        left: 0;
        width: 100%;
        background: rgba(6, 40, 60, 0.8);
        /* Ajusta el ancho según sea necesario */
        height: auto;
        /* Toma el 100% de la altura del viewport */
        overflow-y: auto;
        /* Agrega scroll vertical si es necesario */
    }

    .slider-item {
        /* Estilos generales para cada slider-item */
        padding: 10px;
        margin-bottom: 10px;
    }

    .tags-container {
        top: 5%;
        white-space: nowrap;
        /* Evita el salto de línea */
        overflow-x: auto;
        /* Permite el desplazamiento horizontal si hay muchos elementos */
    }

    .tag-item {
        display: inline-block;
        /* Muestra los elementos en línea */
        margin-right: 10px;
        /* Espaciado entre elementos */
        padding: 5px 10px;
        /* Relleno alrededor del contenido */
        background-color: #f0f0f0;
        /* Color de fondo */
        border-radius: 20px;
        /* Borde redondeado */
        cursor: pointer;
        /* Cambia el cursor al pasar por encima */
    }

    .tag-item:hover {
        background-color: #e0e0e0;
        /* Cambia el color de fondo al pasar por encima */
    }

    .tag-item .badge {
        margin-left: 5px;
        /* Espaciado entre el texto y el contador */
        color: #ff9900;
        background-color: #ccc;
        /* Color de fondo del contador */
        padding: 2px 6px;
        /* Relleno del contador */
        border-radius: 10px;
        /* Borde redondeado del contador */
    }

    .cards-wrapper {
        grid-template-columns: 1fr;
    }

    .info {
        justify-content: center;
    }

    .card-grid-space .num {
        margin-left: 0;
        text-align: center;
    }
}

@media screen and (max-width: 500px) {
    .cards-wrapper {
        padding: 4rem 2rem;
    }

    .card {
        max-width: calc(100vw - 4rem);
    }
}

@media screen and (max-width: 450px) {
    .info {
        display: block;
        text-align: center;
    }

    .info h1 {
        margin: 0;
    }
}
</style>